/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

const DynamicGroupApi = {
  public: {},
  private: {
    /**
     * To fetch filter data
     * @param {*} filterId: (1 = Appointment, 2 = Past Due, 3 = Age)
     * @returns
     */
    fetchFilterData: filterId => ProtectedHttpClient.get(`/groupdatafilters/${filterId}`),
    /**
     * To fetch all available appointment status
     * @returns
     */
    fetchAllAppointmentStatus: (practiceId) => ProtectedHttpClient.get(`/appointmentstatuses/${practiceId}`),
    /**
     * To fetch all available providers
     * @returns
     */
    fetchAllProviders: (practiceId) => ProtectedHttpClient.get(`/providers/${practiceId}`),
    /**
     * To fetch all available facilities
     * @returns
     */
    fetchAllFacilities: (practiceId) => ProtectedHttpClient.get(`/facilities/${practiceId}`),
    /**
     * To fetch all available facilities
     * @returns
     */
    fetchAllAppointmentTypes: (practiceId) => ProtectedHttpClient.get(`/appointmenttypes/${practiceId}`),
    /**
     * To fetch filter data
     * @param {*} payload: Object
     * @returns
     */
    createDynamicGroup: payload => ProtectedHttpClient.post(`/dynamicdatagroups/create`, payload),
    /**
     * To fetch filter data
     * @param {*} { payload, groupId }
     * @returns
     */
    editDynamicGroup: ({ payload, groupId }) => ProtectedHttpClient.put(`/dynamicdatagroups/update/${groupId}`, payload),
    /**
     * To fetch all dynamic groups
     * @returns
     */
    fetchDynamicGroups: () => ProtectedHttpClient.get(`/dynamicgroups/practice/list`),
    /**
     * To fetch group by id
     * @returns
     */
    fetchGroup: groupId => ProtectedHttpClient.get(`/dynamicdatagroup/${groupId}`),
    fetchGroupPatients: (groupId, practiceId) => ProtectedHttpClient.get(`/patient/datafliterlist/${practiceId}/${groupId}`),
  }
};
export default DynamicGroupApi;
